// Pattern that should match any letter with any diacritic

export const LETTERS_WITH_DIACRITIC_REGEX = new RegExp(
  '^[\\p{Letter}\\p{Mark}]+$',
  'u',
);

export const NOT_LETTER_WITH_DIACRITIC_REGEX = new RegExp(
  '[^\\p{Letter}\\p{Mark}]',
  'gu',
);
